<div class="list-wrapper" [ngStyle]="{'padding': contentPadding}">
  <ng-content></ng-content>
</div>
